import { prop } from '@soltalabs/ramda-extra'
import React, { useRef, useLayoutEffect } from 'react'
import Geocoder from 'react-map-gl-geocoder'

import { MAP_BOX_ACCESS_TOKEN } from '../../../utils/env'

import { GeocoderContainer } from './styles'

const onGeocoderResult = (props) => ({ result }) => {
  const {
    dispatchSetAddJobAddress,
    dispatchSetAddJobLocation,
    dispatchSetSelectedJob,
    mapContainerRef,
  } = props
  const {
    place_name: address,
    geometry: { coordinates },
  } = result

  const viewport = {
    longitude: coordinates[0],
    latitude: coordinates[1],
    zoom: 13,
    transitionDuration: 1200,
  }

  const currentRef = prop('current', mapContainerRef)

  if (currentRef && typeof currentRef.onViewportChange === 'function') {
    currentRef.onViewportChange(viewport)
  }

  dispatchSetAddJobLocation({
    longitude: coordinates[0],
    latitude: coordinates[1],
  })
  dispatchSetSelectedJob(null)
  dispatchSetAddJobAddress(address)
}

const SearchBar = ({ mapRef, ...rest }) => {
  const geocoderContainerRef = useRef(null)

  useLayoutEffect(() => {
    const el = geocoderContainerRef.current
    if (!el) return
    while (el.children.length > 1) el.removeChild(el.firstChild)
  })

  return (
    <>
      <GeocoderContainer ref={geocoderContainerRef} className="input-geocoder" />
      <Geocoder
        mapRef={mapRef}
        containerRef={geocoderContainerRef}
        onResult={onGeocoderResult(rest)}
        mapboxApiAccessToken={MAP_BOX_ACCESS_TOKEN}
        countries={'nz,au'}
        placeholder="Search by city or area"
      />
    </>
  )
}

export { SearchBar }
